<div class="container-fluid" *ngIf="!summaryMode">
    <div class="justify-content-start"
            *ngFor="let option of options">
            <mat-checkbox
                    name="answer_{{name}}_{{option}}"
                    [(ngModel)]="checkboxValue[option]"
                    (change)="onClick(option)"
                    id="answer_{{name}}_{{option}}"
                    [disabled]="showNoneOfTheAbove && noneOfTheAbove">
            {{option}}</mat-checkbox>
    </div>
    <div class="justify-content-start" *ngIf="showNoneOfTheAbove">
            <mat-checkbox
                    name="answer_{{name}}_none_of_the_above"
                    [checked]="noneOfTheAbove"
                    (change)="onNoneClick($event.checked)"
                    id="answer_{{name}}_none_of_the_above"
                    [disabled]="value != null && value.length > 0">
             None of these apply to me</mat-checkbox>   
    </div>
    <mat-error *ngIf="question.invalid">required</mat-error>
</div>
<div *ngIf="searchEnabled && (noneOfTheAbove || value != null && value.length > 0) && !summaryMode">
    <div *ngIf="searchedDisclosures.length > 0">
        <div class="row mt-2" *ngFor="let aliasName of searchedDisclosures">
            <u class="ais-picklist-search-name">{{aliasName}}</u>
            <button type="button" class="close" aria-label="Close" (click)="onClick(aliasName)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12">
            {{searchText}}
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-12">
            <jhi-disclosure-search-input (action)="handleDisclosureSearchEvent($event)" [searchIdentifier]="searchIdentifier">
            </jhi-disclosure-search-input>
        </div>
    </div>
</div>
<div class="container-fluid" *ngIf="summaryMode">
    <div class="row">
        <div class="col-12">
            <div class="form-check justify-content-start"
                 *ngFor="let option of options">
                <label class="form-check-label" for="answer_{{name}}_{{option}}">
                    <input type="checkbox" class="form-check-input"
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           disabled="disabled">
                    {{option}}
                </label>
            </div>
            <div class="form-check justify-content-start" *ngIf="showNoneOfTheAbove">
                <label class="form-check-label" for="answer_{{name}}_none_of_the_above">
                    <input type="checkbox" class="form-check-input"
                           name="answer_{{name}}_none_of_the_above"
                           [(ngModel)]="noneOfTheAbove"
                           disabled="disabled">
                    None of the Above
                </label>
            </div>
        </div>
    </div>
</div>
<div *ngIf="searchedDisclosures.length > 0 && summaryMode">
    <div class="row mt-2" *ngFor="let aliasName of searchedDisclosures">
        <u class="ais-picklist-search-name">{{aliasName}}</u>
    </div>
</div>
